<div class="error">

    <!-- title -->
    <div class="error__title text-24 text-bold">
        {{ title }}
    </div>

    <!-- description -->
    <div class="error__description text-16 mt-8" [innerHTML]="description">
    </div>

    <!-- actions-->
    <div class="error__actions mt-8">

        <!-- custom actions -->
        <ng-container *ngIf="url; else defaultActions">
            <button app-button buttonType="outline" buttonTheme="light" (click)="handleActionClick(url)" class="error__action-button">Read More</button>
            <button app-button buttonType="flat" buttonTheme="light" (click)="handleActionClick(supportURL)" class="error__action-button">Contact Us</button>
        </ng-container>

        <!-- default action -->
        <ng-template #defaultActions>
            <button app-button buttonType="outline" buttonTheme="light" (click)="handleActionClick(supportURL)" class="error__action-button">Contact Us</button>            
        </ng-template>

    </div>

    <img class="error__logo mt-16" src="assets/images/biodigital-logo.svg" />

</div>